import * as React from "react"

import * as PopoverPrimitive from "@radix-ui/react-popover"
import { type VariantProps, cva } from "class-variance-authority"

import { OVERLAY_BORDER } from "@/components/ui/overlay"
import { cn } from "@/lib/utils"

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

/** Name a variant, not a `w-*`: `default`'s `min-w-[16rem]` outranks a smaller width. */
const popoverVariants = cva(
  `z-50 rounded-md border ${OVERLAY_BORDER} bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2`,
  {
    variants: {
      variant: {
        default: "w-auto min-w-[16rem] p-4",
        menu: "w-64 p-2",
        plain: "w-auto p-0",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
)

interface PopoverContentProps
  extends
    React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>,
    VariantProps<typeof popoverVariants> {}

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  PopoverContentProps
>(({ className, variant, align = "center", sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(popoverVariants({ variant }), className)}
      {...props}
    />
  </PopoverPrimitive.Portal>
))
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverContent }
